<template>
  <div v-if="loading" class="col-span-12 intro-y">
    <div>
      <div class="my-2" v-if="series.length > 0">
        <div class="flex flex-row justify-between mb-2" v-if="start_date">
          <p class="mt-2">Reporte de horas por mes</p>
          <span class="border rounded p-2"
            >{{ start_date }} a {{ end_date }}</span
          >
        </div>
        <VueApexCharts
          width="100%"
          height="500"
          type="bar"
          :options="options"
          :series="series"
        ></VueApexCharts>
      </div>
    </div>
  </div>
  <div class="col-span-12 intro-y" v-else>
    <Loading />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'TasksMonthsAccount',
  data() {
    return {
      loading: false,
      start_date: null,
      end_date: null,
      team_session: null,
      account_session: null,
      series: [],
      options: {
        chart: {
          type: 'bar',
        },
        plotOptions: {
          bar: {
            vertical: true,
          },
        },
        colors: ['#00E396'],
        dataLabels: {
          style: {
            fontSize: '18px',
          },
          formatter: function (val, opt) {
            const goals =
              opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
                .goals

            if (goals && goals.length) {
              return `${val} / ${goals[0].value}`
            }
            return val
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ['Usadas', 'Total'],
          markers: {
            fillColors: ['#00E396', '#775DD0'],
          },
        },
      },
    }
  },
  async created() {
    try {
      await this.get(
        `task/report-month?team_session=${localStorage.session_team}&account_session=${localStorage.session_account}`
      ).then((data) => {
        //console.log(data)
        const { list, start_date, end_date } = data
        this.start_date = start_date
        this.end_date = end_date
        var array_data = []

        list.map((item) => {
          var data_goals = {
            name: 'Total',
            value: item.hours,
            strokeWidth: 10,
            strokeFontSize: 10,
          }
          if (parseInt(item.hours_used) > item.hours) {
            data_goals.strokeHeight = 5
            data_goals.strokeLineCap = 'round'
            data_goals.strokeColor = '#d32929'
          } else {
            data_goals.strokeHeight = 10
            data_goals.strokeColor = '#775DD0'
          }

          var row = {
            x: item.name_dates,
            y: item.hours_used,
            goals: [data_goals],
          }
          array_data.push(row)
          console.log(array_data)
        })
        this.loading = true

        this.addSerie(array_data)
      })
    } catch (error) {
      window.$toast.error(error)
    }
  },
  async beforeMount() {
    this.account_session = localStorage.session_account
    this.team_session = localStorage.session_team
  },
  methods: {
    addSerie(array_data) {
      var series = [
        {
          name: 'Usadas',
          data: array_data,
        },
      ]
      this.series = series
    },
    ...mapActions(['get']),
  },
  components: {
    VueApexCharts,
    Loading,
  },
}
</script>



// WEBPACK FOOTER //
// TasksMonthsAccount.vue?bf621b5a